/**
 * @generated SignedSource<<7c545f2ebbe6c3380f6e4a8068a51c44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTomraCreateScreenQuery$variables = Record<PropertyKey, never>;
export type IntegrationTomraCreateScreenQuery$data = {
  readonly store: {
    readonly name: string;
  };
  readonly tomraStores: ReadonlyArray<{
    readonly accountId: string;
    readonly assigned: boolean;
    readonly externalId: string;
    readonly name: string | null;
  }>;
};
export type IntegrationTomraCreateScreenQuery = {
  response: IntegrationTomraCreateScreenQuery$data;
  variables: IntegrationTomraCreateScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigned",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTomraCreateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TomraStore",
        "kind": "LinkedField",
        "name": "tomraStores",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v0/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationTomraCreateScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TomraStore",
        "kind": "LinkedField",
        "name": "tomraStores",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v0/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "419e57ba1384cab1dd8f7f4344af5d65",
    "id": null,
    "metadata": {},
    "name": "IntegrationTomraCreateScreenQuery",
    "operationKind": "query",
    "text": "query IntegrationTomraCreateScreenQuery {\n  store {\n    name\n    id\n  }\n  tomraStores {\n    accountId\n    externalId\n    name\n    assigned\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6180c120f72db6a23a76ae006438050";

export default node;
